import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { EntityDataDispatcher } from '../entity-data/entity-data.dispatcher';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { Appointment } from './models/appointment.model';
import { billAppointment } from './appointment-data.actions';
import { AppointmentDataBuilder } from './appointment-data.builder';
import { IState } from './appointment-data.reducer';
import { AppointmentDataStore } from './appointment-data.store';
import { fetchList } from '../entity-data/entity-data.actions';
import {
  ALL_LIST_FILTER,
  ISearchParams,
  SearchParamsEnum,
} from '../entity-data/entity-data.data';
import { DateTimeService } from 'i2g-ng-utils';

@Injectable()
export class AppointmentDataDispatcher extends EntityDataDispatcher<
  IState,
  Appointment
> {
  constructor(
    private _dateTimeService: DateTimeService,
    store: Store<any>,
    appointmentDataStore: AppointmentDataStore,
    appointmentDataBuilder: AppointmentDataBuilder,
    globalBannerService: GlobalBannerService,
    translateService: TranslateService
  ) {
    super(
      store,
      appointmentDataStore,
      appointmentDataBuilder,
      globalBannerService,
      translateService
    );
  }

  fetchList(listFilter: string = ALL_LIST_FILTER) {
    // appointments always fetch the list for current month and year
    const fetchParams: ISearchParams = {
      [SearchParamsEnum.page]: 1,
      [SearchParamsEnum.month]: this._dateTimeService.getCurrent('month') + 1, // range [ 1, 12 ]
      [SearchParamsEnum.year]: this._dateTimeService.getCurrent('year'),
    };

    this.store.dispatch(fetchList(this.entityType, fetchParams, listFilter));
  }

  filterSchedule(year: number, month: number) {
    const filterParams: ISearchParams = {
      page: 1,
      year,
      month,
    };

    this.store.dispatch(
      fetchList(this.entityType, filterParams, ALL_LIST_FILTER)
    );
  }

  billAppointment(appointmentId: string, clientReferenceId: string) {
    this.store.dispatch(
      billAppointment(this.entityType, appointmentId, clientReferenceId)
    );
  }
}
